export default {"src":"/_next/static/media/certifiedBlack.642cb1ab.svg","height":26,"width":27};